import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";

export interface Error {
  status: boolean;
  message: string;
}

export interface YoutubeChannel {
  errors: Error;
}

@Module
export default class YoutubeChannelModule extends VuexModule implements YoutubeChannel {
  errors = {} as Error;
  channel = [];
  channels = [];

  /**
   * Get current question object
   * @returns question
   */

  /**
   * Get list of questions object
   * @returns questions
   */
  get currentChannels() {
    return this.channels;
  }

  /**
   * Get questions errors
   * @returns array
   */
  get getChannelErrors() {
    if (JSON.stringify(this.errors) === "{}") {
      this.errors.status = true;
      this.errors.message = "";
    }
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors.status = error.status;
    this.errors.message = error.message;
    if (typeof error.errors !== "undefined") {
      let txt = "";
      const size = Object.keys(error.errors).length;
      if (size > 0) {
        Object.keys(error.errors).forEach(function (key) {
          txt += error.errors[key] + "<br />";
        });
        this.errors.message = txt;
      }
    }
  }

  @Mutation
  [Mutations.SET_CHANNELS](channels) {
    this.channels = channels;
  }

  @Action
  [Actions.GET_CHANNELS](credentials) {
    return ApiService.get("admin/youtube-channel/all", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_CHANNELS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.END_COOPERATION](credentials) {
    return ApiService.get("admin/youtube-channel/end", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.ACCEPT_CHANNEL](credentials) {
    return ApiService.post("admin/youtube-channel/accept", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.REJECT_CHANNEL](credentials) {
    return ApiService.post("admin/youtube-channel/reject", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.PRINT_CONTRACT](credentials) {
    console.log(credentials);
    return ApiService.get("youtube-channel/contract-pdf", credentials, {
      responseType: "blob",
    })
      .then(({ data }) => {
        const blob = new Blob([data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "contract.pdf";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      })
      .catch(({ response }) => {
        console.error("PDF Download Error:", response);
        this.context.commit(
          Mutations.SET_ERROR,
          response?.data || "An error occurred while downloading the PDF."
        );
      });
  }
}
